import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import VueJwtDecode from "vue-jwt-decode";

// CLIENT PAGES
import MainLayout from "../views/layout/main.vue";
import DashboardKabayan from "../views/pages/DashboardKabayan.vue";
import PostsKabayan from "../views/pages/Mention.vue";
import SourcesKabayan from "../views/pages/Sources.vue";
import AnalyticsKabayan from "../views/pages/AnalyticsKabayan.vue";
import Maps from "../views/pages/analytics/Maps.vue";
import Narasumber from "../views/pages/analytics/Narasumber.vue";
import TrashBin from "../views/pages/TrashBin.vue";
import Keyword from "../views/pages/settings/Keyword.vue";
import Users from "../views/pages/settings/User.vue";
import Channel from "../views/pages/settings/Channel.vue";
import Media from "../views/pages/settings/Media.vue";
import Profile from "../views/pages/Profile.vue";
import DetailAkun from "../views/pages/DetailAkun.vue";
import Login from "../views/pages/Login.vue";
import PageNotFound from "../views/pages/Error404.vue";

Vue.use(VueRouter);
const routes = [
  // CLIENT ROUTES
  {
    path: "/",
    name: "Layout",
    component: MainLayout,
    redirect: "/dashboard",
    children: [
      // DASHBOARD
      {
        path: "/dashboard",
        name: "Dashboard",
        component: DashboardKabayan,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // POST
      {
        path: "/posts",
        name: "Posts",
        component: PostsKabayan,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // SOURCES
      {
        path: "/sources",
        name: "Sources",
        component: SourcesKabayan,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS GENERAL
      {
        path: "/analytics",
        name: "Analytics",
        component: AnalyticsKabayan,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS MAPS
      {
        path: "/maps",
        name: "Maps",
        component: Maps,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // ANALYTICS NARASUMBER
      {
        path: "/narasumber",
        name: "Narasumber",
        component: Narasumber,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // TRASH BIN
      {
        path: "/trashbin",
        name: "TrashBin",
        component: TrashBin,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // SETTING KEYWORD
      {
        path: "/setting-keyword",
        name: "Keyword",
        component: Keyword,
        meta: {
          requiresAuth: true,
          permission: [1, 2, 3],
        },
      },
      // SETTING USERS
      {
        path: "/setting-users",
        name: "Users",
        component: Users,
        meta: {
          requiresAuth: true,
          permission: [1, 2, 3],
        },
      },
      // SETTING CHANNEL
      {
        path: "/setting-channel",
        name: "Channel",
        component: Channel,
        meta: {
          requiresAuth: true,
          permission: [1, 2, 3],
        },
      },
      // SETTING MEDIA
      {
        path: "/setting-media",
        name: "Media",
        component: Media,
        meta: {
          requiresAuth: true,
          permission: [1, 2, 3],
        },
      },
      // PROFILE
      {
        path: "/profile",
        name: "Profile",
        component: Profile,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
      // DETAIL AKUN
      {
        path: "/detail-akun",
        name: "DetailAkun",
        component: DetailAkun,
        meta: {
          requiresAuth: true,
          permission: [2, 3, 4],
        },
      },
    ],
  },
  // LOGIN
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  // ERROR 404
  { path: "*", name: "Error404", component: PageNotFound },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      if (to.matched.some((record) => record.meta.permission)) {
        let user_role;
        if (store.getters.token) {
          let token_decode = VueJwtDecode.decode(store.getters.token);
          user_role = token_decode.role;
        } else {
          user_role = store.getters.user.role;
        }
        if (to.meta.permission.includes(user_role)) {
          next();
          return;
        } else {
          next("/PageNotFound");
          return;
        }
      }
      next();
      return;
    }
    next("/login");
  } else {
    next();
  }
});

export default router;
